import React, { useState, useEffect} from 'react'
import "./AdAccountModal.css"
import UNIVERSAL from '../../config/config';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { CircularProgress, Modal } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import errorIcon from "../../assets/images/error.svg" ;
import noFbPageIcon from "../../assets/images/no-fb-page.png" 
import { fbActions } from '../../store/fb-slice';
import UserFbPages from '../Home/LinkFbPage/UserFbPages';
import { useNavigate } from 'react-router-dom';

const AdAccountModal = ({setShowAdModal, pages, userData, user, setUpdated, showModal, getUserFbPages, tokenInvalid}) => {
    const[selectedPage, setSelectedPage]=useState(userData?.facebook_page_name ? userData?.facebook_page_name : "");
    const [selected,setSelected]=useState();
    const [loading, setLoading] = useState(false)
    const loginData = useSelector(state => state.login)
    const homePageProfile = useSelector(state => state.homePageProfile.data) 
   
    const [selectPageModal, setSelectPageModal] = useState(false);
    const [selectPermissionModal, setPermissionModal] = useState(false);
    const [allPages, setAllPages] = useState([]);
    const [showFbPageModal,setShowFbPageModal]=useState(false);
    const fbDetail = useSelector(state => state.fb.fbDetails);
    const selectedFbPage = useSelector(state => state.fb.selectedFbPage);
    const app_fb_user_id = useSelector(state => state.fb.app_fb_user_id);

    const navigate = useNavigate()

    const dispatch = useDispatch() ;

    async function saveFacebookUser() {
      console.log(fbDetail, "FB DETAIL")
      return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/save_fb_user", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
        },
        body: JSON.stringify({
          "business_id": user?.app_business_id?.toString(),
          "user":fbDetail,
          "platform": "web"
        })
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.data) {
            dispatch(fbActions.setFbUserId(responseJson.data.app_fb_user_id));
            getUserFbPages()
          } else {
            // error
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  
    function handleFbConnect() {
      FB.login(
        function (response) {
          if (response.authResponse) {
            FB.api(`/me/permissions`, "GET", {}, function (res) {
              const allPermissions = check_permissions(res.data)
              if (allPermissions) {
                get_account_pages(response.authResponse.userID, `/${response.authResponse.userID}/accounts?fields=id ,access_token, category, name, about, picture, cover, is_published, tasks, promotion_eligible,business`, [])
  
                FB.api(`/${response.authResponse.userID}?fields=name,id,picture,email`, function (res) {
                  if (res) {
                    let data = { ...response.authResponse, ...res };
                    dispatch(fbActions.setFbDetails({ name: data.name, email: data.email, access_token: data.accessToken, is_long_lived_token: false, id: data.id }))
                    // saveFacebookUser()
                    // setShowFbPageModal(true);
                    // setShowAdModal(false)
                  }
                })
                setSelectPageModal(true)
              } else {
                // SHOW PERMISSIONS NOT GRANTED
                // FB.logout();
                setPermissionModal(true)
              }
            })
          } else {
            console.log('User cancelled login or did not fully authorize.');
          }
        },
        {
          scope: 'pages_read_engagement, email, public_profile, pages_show_list, business_management, pages_manage_metadata',
          auth_type: 'rerequest',
        }
      );
    }

    const get_account_pages = (userID, url, pages) => {
      /* global FB */
      let tmp = pages
      FB.api(url, (res) => {
        if (res.data.length !== 0) {
          tmp = [...pages, ...res.data]
          const new_url = `/${userID}/accounts?fields=id ,access_token, category, name, about, picture, cover, is_published, tasks, promotion_eligible,business&after=${res.paging.cursors.after}`;
          get_account_pages(userID, new_url, tmp);
        } else {
          setAllPages(tmp)
        }
      })
      return;
    };
  
    const check_permissions = (data) => {
      let count = 0;
      const permissions = ["pages_read_engagement", "email", "public_profile", "pages_show_list", "business_management", "pages_manage_metadata"]
      data.map((item) => {
        if (permissions.includes(item.permission) && item.status === "granted") {
          count = count + 1
        }
      })
      return count === permissions.length ? true : false;
    }
  
    function handleCloseModal(){
      setShowFbPageModal(false);
    }
  
    useEffect(() => {
      if ( user?.app_business_id && fbDetail)     saveFacebookUser();
    }, [fbDetail])
  
    useEffect(()=>{
      async function claimFacebookPage() {
        return fetch(UNIVERSAL.BASEURL_1 + '/bizv2/claim_facebook_page', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
          },
          body: JSON.stringify({
            "app_fb_user_id": app_fb_user_id?.toString(),
            "business_id": user?.app_business_id?.toString(),
            "is_claimable": true,
            "page_data": selectedFbPage,
            "version": 2
          })
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson.data) {
              // console.log(responseJson.data)
              if (!responseJson.data.has_whatsapp_business_number) {
                navigate("/connect-whatsapp")
              }
            } else {
              // error
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (app_fb_user_id && user?.app_business_id && selectedFbPage) claimFacebookPage();
    },[selectedFbPage,app_fb_user_id])

    function handleSelectedPage(name, id){
        setSelectedPage(name)
        const selectedPage = pages.find(allId => allId.id === id);
        setSelected(selectedPage);
    }

    async function handleSelectedFbPageDone() {
        setLoading(true)
        return fetch(UNIVERSAL.BASEURL_1 + '/bizv2/switch_facebook_page', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
            },
            body: JSON.stringify({
                app_fb_user_id: Number(userData?.app_fb_user_id),
                business_id: String(user?.app_business_id),
                page_data: selected,

            })
        })
            .then((response) => response.json())
            .then((responseJson) => {
                setShowAdModal(false);
                setUpdated(responseJson);
                setLoading(false)
                
                if (!responseJson.data.has_whatsapp_business_number) {
                  navigate("/connect-whatsapp")
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false)
            });
    }

    return (
        <>
            {showFbPageModal && <UserFbPages allPages={allPages} closeModal={handleCloseModal} />}
            <Modal open={showModal} onClose={() => setShowAdModal(false)} >
            <div className="adModal">
                <div className="adModal__close">
                    <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/close-circle.svg" alt="cross-icon" onClick={()=>setShowAdModal(false)} />
                </div>
                <div className="adModal__inner">
                    <h2 className='ad__heading'>Change your facebook page</h2>
                    <p className='ad__subHeading'>Change your FB page and proceed</p>
                    {!tokenInvalid &&
                        <>
                      <p style={{fontSize: "0.9rem",margin: 0, color: "#00000080" , marginTop: "1rem"}} >Select the page in which you want to run ads</p>
                      <div className="ad__fbPages">
                        <div className="radioGroups">
                            {!pages?.length &&  !tokenInvalid && 
                            <div className='noFbPage' >
                              <img src={noFbPageIcon} />
                              <h3>No FB pages available</h3>
                              <p style={{color: "#808080"}} >There are no pages available under this account. </p>
                            </div>
                            }
                            {pages && pages.map((page,index)=>{
                                return (
                                    <div className="radioGroup" key={index}>
                                        <input type="radio" name={page?.name} value={page?.name} onChange={(e)=>handleSelectedPage(page?.name,page?.id)} checked={page?.name===selectedPage} />
                                        <div>{page?.name?.slice(0,1)}</div>   
                                        <h6>{page?.name}</h6>
                                    </div>
                                )
                            })}
                         
                        </div>
                        </div>
                        </> 

                  }
                    {tokenInvalid && 
                      <div className="ad__fbPages">
                              <div className='tokenInvalidPage'>
                                <img src={errorIcon} />
                                <h3>Facebook Session expired</h3>
                                <button  onClick={handleFbConnect}>Reauthenticate FB</button>
                              </div> 
                        </div> 
                        }
                    <div className='orSeperator'>
                        <p>Or</p>
                    </div>
                    <p className='changeAccountLink'  onClick={handleFbConnect} >Change your Facebook account</p>
                    <button disabled={loading || !pages}  className='ad__btn' onClick={handleSelectedFbPageDone}>
                        {loading ?
                        <CircularProgress style={{color: "#eee", width: "1.5rem", height: "1.5rem"}} />:  
                         <>Done</>
                        }    
                    </button>
                </div>
            </div>
            </Modal>
        </>
    )
}

export default AdAccountModal